
                export default function (Component) {
                    Component.__source = "library/layouts/VabLayoutComprehensive/index.vue"
                }
            